export default class RouteParamsBuilder {
    private pathname: string;
    private urlParams: URLSearchParams;

    constructor(url: string) {
        const urlSplit = url.split('?');
        this.pathname = urlSplit[0];
        this.urlParams = new URLSearchParams(urlSplit[1] ? '?' + urlSplit[1] : '');
    }

    public param(paramName: string, defaultValue: string | null = null): string | null {
        return this.urlParams.get(paramName) || defaultValue;
    }

    public set(paramName: string, paramValue: string): void {
        paramValue === '' ? this.remove(paramName) : this.urlParams.set(paramName, paramValue);
    }

    public remove(paramName: string): void {
        this.urlParams.delete(paramName);
    }

    public exists(paramName: string): boolean {
        return this.urlParams.has(paramName);
    }

    public path(): string {
        const params = this.urlParams.toString();
        return params !== '' ? this.pathname + '?' + params : this.pathname;
    }
}
